button {
	/* Pos */
	position: relative;
	overflow: hidden;

	/* Flex */
	display: flex;
	align-items: center;
	gap: 5px;

	/* Spacing */
	padding: 10px;

	/* Color */
	background-color: var(--primary-color);
	color: white;

	/* Border */
	border: 1px solid var(--primary-color);
	border-radius: 5px;

	/* Text */
	font-family: inherit;

	/* Transitions */
	cursor: pointer;
	transition: background 400ms;
}

button.loading::before {
	content: "";
	width: 16px;
	height: 16px;
	border: 1px solid var(--disabled-color);
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;
}

button.loading > img {
	display: none !important;
}

button:disabled > img {
	filter: brightness(0.4);
}

img {
	height: 16px;
	width: 16px;
}

button:disabled > p {
	color: var(--disabled-color);
	pointer-events: none;
}

button:hover {
	background-color: var(--primary-highlight);
}

button:disabled {
	background-color: #00000000;
	color: var(--disabled-color);
	border: 1px solid var(--disabled-color);
	cursor: default;
	pointer-events: none;
}

p {
	margin: 0;
	color: white;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}